<section class="seller-min-outer add">
     
              <div class="container" style="max-width: 80%;
        margin: 8% auto 0%;">
        <div class="row">
            <div class="col-lg-12">
                   <div class="min-text-page">
                        <div class="inner-sall-text outer">SELL YOUR PROPERTY  ON
                    </div>
                         <div class="waviy">
 <span style="--i:3">Y</span>
   <span style="--i:4">O</span>
   <span style="--i:5">U</span>
   <span style="--i:6">R</span>
   <span class="ifun" style="--i:7">T</span>
   <span style="--i:8">E</span>
   <span style="--i:9">R</span>
     <span style="--i:9">M</span>
   <span  style="--i:10">S</span>
  </div>
                   </div>
  
                    <div class="min-buuton">
                          <button class="seller-buttn" routerLink="/quick-listing" style="background-color: #bd0c0c">Start Listing</button>
                </div>
                 
                 
                 
               
              </div>
            </div>
        </div>
 </section>

<section class="title-text">
   <div class="min-texxt">
    <div class="container" style="max-width: 80%;
    margin: auto;">
              <h1>Why sell on <span>propira.com </span></h1>
          <p>  Every property is verified by the Propira Verification Experts taking into account all necessary parameters. Our team will help you know the true market value and will update you about the current market value so that your property is sold at a reasonable price.</p>
       
       
       <!--  <div class="sell"><h1>Sell on propira</h1></div>-->
       </div>
        </div>


</section>

<section style="padding: 50px 0px " class="min-outer-min">
  
    <div class="container" style="max-width: 80%;
    margin: auto;">
<div class="min-icon-text">
          <h5>SELLER BENEFITS</h5>
        </div>      <div class="row">
       
           <div class="col-lg-3">
               <div class="min-box">
                  <div class="img-icon">
                  <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="assets/img-seller/icon-new-5.png">
                </div>
                   <div class="tetx-icon">
                  <h1>GENUNIE BUYERS</h1>
                </div>
               </div>
          </div>
             <div class="col-lg-3">
               <div class="min-box">
                  <div class="img-icon">
                  <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="assets/img-seller/icon-new-6.png">
                </div>
                   <div class="tetx-icon">
                  <h1>BEST VALUE OF YOUR PROPERTY</h1>
                </div>
               </div>
          </div>
             <div class="col-lg-3">
               <div class="min-box">
                  <div class="img-icon">
                  <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="assets/img-seller/icon-new-7.png">
                </div>
                   <div class="tetx-icon">
                  <h1>GREAT SUPPORT TILL DEAL CLOSURE</h1>
                </div>
               </div>
          </div>

   <div class="col-lg-3">
               <div class="min-box">
                  <div class="img-icon">
                  <img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" data-src="assets/img-seller/icon-new-8.png">
                </div>
                   <div class="tetx-icon">
                  <h1>FREE ADVERTISEMENT SUPPORT</h1>
                </div>
               </div>
          </div>          
          <div class="last-butn">
            <button class="seller-buttn" routerLink="/quick-listing" style="background-color: #bd0c0c">Start Listing</button>
          </div>
         
      </div>
      
  
   </div>
    
</section>

   <style type="text/css">section.seller-min-outer {
    background-image: url(assets/img-seller/heroDesktop.1bf6f1e1.jpg);
    background-size: cover;
    position: relative;
   /* padding: 7% 0px;*/
    background-attachment: fixed;
}
body, h1, h2, h3, h4, h6, p, strong {
    font-family: cambria !important;
}
span.ifun {
    margin-left: 20px;
}
.inner-sall-text h2 {
    padding: 15px 0;
    line-height: 95px;
    font-size: 70px;
    font-weight: bolder;
    color: #fff;
}
.v-min {
    /* padding: 12px; */
    /* border: 1px solid #989898; */
    /* height: 310px; */
    width: 90%;
    margin: auto;
}
.mion-img-seller img:hover {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
    transition: transform .3s ease-out;
}
.mion-img-seller img {
    width: 41%;
    height: 99px;
    object-fit: contain;
}
.eqr-btn button.seller-buttn {
    width: 40%;
}
.ul-text.adsd {
    padding: 10% 0px;
}
button.seller-buttn {
    color: #fff;
    border: 2px solid transparent;
    display: inline-block;
    font-size: 30px;
    font-weight: 400;
    text-decoration: none;
    background-image: none;
    border-radius: 2em;
    min-width: 7em;
    padding: 7px 49px;
    text-align: center;
}
.min-texxt h1 {
    font-weight: 700;
    color: #bd0c0c;
}
.min-texxt p {
    font-size: 16px;
    color: #444;
    font-weight: 600;
}
button.seller-buttn:hover {
    background: #5d5d5dcc !important;
    box-shadow: 1px 1px 2px #fff !important;
    color: red;
    text-decoration: none;
    transition: all 250ms linear;
}

.ul-text li {
    list-style: none;
}
.mion-img-seller img {
    width: 41%;
}
.ul-text ul {
    padding: 0px;
}
.ul-text span {
    padding-right: 10px;
    color: #bd0c0c;
}
.ul-text img {
    width: 100%;
}
.ul-text h4 {
    color: #bd0c0c;
}

section.min-outer-min.add {
    background-color: #e8e8e8;
    margin-top: 50px;
    padding-bottom: 50px;
}
.min-texxt {
    padding: 30px 0px;
}

.min-texxt {
    width: 80%;
    margin: auto;
}

.img-icon img {
    width: 30%;
}
.min-texxt h2 {


    margin-bottom: 20px;
    font-size: 26px;
    font-weight: 700;
    text-align: center;
    color: #292929;
}
.tetx-icon h1 {
    font-weight: 700;
    font-size: 23px;
    margin: 25px 0px;
}
.min-icon-text h5 {
    padding-bottom: 10px;
    font-size: 17px;
    font-weight: 700;
    color: #444;
    border-bottom: 2px solid #212529;
    width: 13%;
    margin-bottom: 30px !important;
    margin: auto;
    text-transform: uppercase;
}
.last-butn {
    text-align: center;
    width: 100%;
}
.min-box {
    height: 210px;
}
.mion-text-seller h6 {
    color: #444;
    font-size: 18px;
    margin: 10px 0px;
}
.v-min {
    text-align: center;
}
.mion-text-seller span {
    color: #bd0c0c;
}
.mion-text-seller p {
    text-align: center;
  font-size: 14px;
    color: #424d56;
}
/*.listting-btn {
    text-align: center;
}
.listting-btn button.seller-buttn {
    width: 20%;
}
.listting-btn {
    margin: 30px 0px;
}*/


.inner-sall-text ul li {
    text-decoration: none;
    list-style: none;
    text-align: left;
    margin: 2px 0px;
    font-size: 15px;
    font-weight: 600;
    padding: 8px 0px;
}
.inner-sall-text ul {
    width: 40%;
    background-color: #fff;
    padding: 20px;
    border-radius: 2px;
}
.inner-sall-text ul li span {
    padding-right: 10px;
    color: #bd0c0c;
}
.row {
    width: 100%;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}


.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0,0,0,.2));
}
.waviy span {
  position: relative;
  display: inline-block;
  font-size: 40px;
  color: #fff;
  text-transform: uppercase;
  animation: waviy 1s infinite;
  animation-delay: calc(.1s * var(--i))
}
@keyframes waviy {
  0%,40%,100% {
    transform: translateY(0)
  }
  20% {
    transform: translateY(-20px)
  }
}.inner-sall-text.outer {
    font-size: 50px;
    font-weight: 700;
    font-family: Roboto,-apple-system,BlinkMacSystemFont,Helvetica Neue,Segoe UI,sans-serif;
    color: #ffff;
}
/*.min-text-page {
   text-align: center;
}*/
.min-text-page span {
    font-size: 50px;
    font-weight: 700;
    font-family: Roboto,-apple-system,BlinkMacSystemFont,Helvetica Neue,Segoe UI,sans-serif;
    color: #ffff;
}
.waviy {
    margin-left: 20px;
}
section.seller-min-outer ul {
    background-color: #56565687;
    padding: 30px;
    margin-top: 50px;
}
section.seller-min-outer ul li {
    color: #fff;
    font-size: 16px;
    text-align: justify;
    font-weight: 500;
    word-spacing: 3px;
    list-style: none;
}
button.seller-buttn {
    margin: 10px 0px;
}
.ul-text h4 {
    color: #bd0c0c;
    font-size: 25px;
    text-transform: capitalize;
    font-weight: 600;
}
.ul-text.adsd p {
    text-align: justify;
    font-size: 16px;
    color: #444;
}

.container-block {
  color: #fff;
  display: inline-block;
  max-width: 100%;
  width:100%;
  position: relative;
}
.container-block::before {
  background-color: rgba(0, 0, 0, 0.3);
  bottom: 0;
  content: '';
  display: block;
  position: absolute;
  top: 0;
  width: 100%;
}
.container-block:hover .inner-block:before,
.container-block:hover .slider-top-right:after {
  height: 100%;
}
.container-block:hover .inner-block:after,
.container-block:hover .slider-top-right:before {
  width: 100%;
}
.container-block img {
  display: block;
  max-width: 100%;
}

.block-content {
  position: absolute;
  bottom: 10%;
  left: 10%;
  padding: 0 1rem;
}

.slider-top-right:before,
.inner-block:after {
  height: 4px;
  transition: width .75s ease;
  width: 0%;
}

.slider-top-right:after,
.inner-block:before {
  height: 0%;
  transition: height .75s ease;
  width: 4px;
}

.inner-block:before,
.inner-block:after,
.slider-top-right:before,
.slider-top-right:after {
  background-color: #fff;
  content: '';
  display: block;
  position: absolute;
}

.inner-block {
  font-size: 2em;
  width: 90%;
  height: 90%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.inner-block:before {
  bottom: 0;
  left: 0;
}
.inner-block:after {
  bottom: 0;
  right: 0;
}

.slider-top-right {
  position: relative;
  width: 100%;
  height: 100%;
}
.slider-top-right:before {
  top: 0;
  left: 0;
}
.slider-top-right:after {
  top: 0;
  right: 0;
}
section.seller-min-outer::before {
    background-color: rgb(0 0 0 / 58%);
    bottom: 0;
    content: '';
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
}
.mobile {
    display: none;
}

div#mod-stripContent-1 {
    background-color: #56565687;
    padding: 30px;
    width: 70%;
    margin: 70px 0px;
}
.clearfix.hidden.outer {
    color: #fff;
    font-size: 16px;
    text-align: justify;
    font-weight: 500;
    word-spacing: 3px;
    list-style: none;
}
section.seller-min-outer.add {
    background-image: url(assets/img-seller/property.jpg);
    background-position: right center;
    background-repeat: no-repeat;
   /* height: 320px;*/
}
section.whay-about {
    background-image: url(assets/img-seller/property.jpg);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 100vh;
    position: relative;
    padding:10% 0px;
    
}
section.whay-about::before {
    background-color: rgb(0 0 0 / 43%);
    bottom: 0;
    content: '';
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
}
.min-image-slider {
    text-align: center;
    padding: 8% 0px;
}
.min-image-slider h4 {
    color: #fff;
}
.min-image-slider p {
    color: #fff;
}
.min-image-slider img {
    width: 10%;
}
.about-slider-text {
    text-align: center;
    margin: 40px 0px;
    color: #292929;
}
.about-slider-text {
    margin: 40px 0px;
    color: #ffffff;
    position: absolute;
    top: 0px;
    text-align: center;
    width: 100%;
}
@media(max-width:992px){.img-icon img {
    width: 20%;
}.min-box {
    height: auto;
    margin-bottom: 70px;
}

  .min-buuton {
    text-align: center;
}
  .min-texxt {
    padding-bottom: 0px;
}
    .row {
    width: auto;
}
.inner-sall-text.outer {
    font-size: 28px;
    text-align: center;
}
.waviy {
    text-align: center;
}
.min-text-page span {
    font-size: 28px;
}
section.seller-min-outer ul {
    width: 100%;
}
section.seller-min-outer ul li {
    font-size: 14px;
}
button.seller-buttn {
    width: 80%;
    margin: auto;
}
.min-texxt {
    width: 100%;
    margin: auto;
}
.min-icon-text h5 {
    width: 70%;
    margin: auto;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 40px;
}
.min-box {
    text-align: center;
}


.ul-text.adsd {
    padding: 4% 0px;
}
section.whay-about {
    height: auto;
}
.min-image-slider p {
    font-size: 16px;
    width: 70%;
    margin: auto;
    text-align: center;
    margin-bottom: 20px;
    height: 90px;
}
.about-slider-text {
    top: -30px;
}
.about-slider-text h1 {
    font-size: 30px;
}
.waviy {
    margin-left: 15px;
}
span.ifun {
    margin-left: 15px;
}

}
@media(max-width:320px){
    .inner-sall-text.outer {
    font-size: 14px;
}
.min-text-page span {
    font-size: 14px;
}
}

/*.min-buuton {
    text-align: center;
}*/
.min-text-page {
    margin: 50px 0px;
}
.min-buuton{
  margin-bottom: 50px;
}
.ul-text li span img {
    width: 9%;
}
.ul-text li {
    list-style: none;
    font-size: 20px;
    font-weight: 700;
    margin: 20px 0px;
}
.ul-text li span i {
    font-size: 48px;
}
.min-texxt h2 span {
    color: #bd0c0c;
}
section.min-outer-min {
    background-color: #efefef;
}
.sell h1 {
    font-size: 27px;
    font-weight: 700;
    padding-bottom: 25px;
    margin: 0px;
}
.min-texxt {
    padding-bottom: 10px;
} 
.img-icon {
    height: 65px;
}</style>